import {useEffect, useRef} from "react";
import {css} from "@emotion/react";
import {useInView, useSpring} from "framer-motion";

export const pulseHeartbeatAnimation = (duration: string, iteration: string) => css`
    animation: heartbeat ${duration} ease-in-out ${iteration} both;

    @keyframes heartbeat {
        from {
            transform: scale(1);
            transform-origin: center center;
            animation-timing-function: ease-out;
        }
        10% {
            transform: scale(0.91);
            animation-timing-function: ease-in;
        }
        17% {
            transform: scale(0.98);
            animation-timing-function: ease-out;
        }
        33% {
            transform: scale(0.87);
            animation-timing-function: ease-in;
        }
        45% {
            transform: scale(1);
            animation-timing-function: ease-out;
        }
    }
`;

const buildArgs = (once?: boolean, rootMargin?: string) => {
    let args = {};
    if (once) {
        if (!!rootMargin) {
            args = {once: true, rootMargin: rootMargin};
        } else {
            args = {once: true};
        }
    }
    if (!!rootMargin && !once) {
        args = {rootMargin: rootMargin};
    }
    return args;
};

export const animationOpacityScale = (startOpacity: number, startScale: number, once?: boolean, rootMargin?: string) => {
    const ref = useRef<HTMLDivElement>(null);
    const inView = useInView(ref, buildArgs(once, rootMargin));

    const opacity = useSpring(inView ? 1 : startOpacity, {stiffness: 100, damping: 20});
    const scale = useSpring(inView ? 1 : startScale, {stiffness: 100, damping: 20});

    useEffect(() => {
        opacity.set(inView ? 1 : startOpacity);
        scale.set(inView ? 1 : startScale);
    }, [inView, opacity, scale, startOpacity, startScale]);

    return {
        ref,
        style: {
            opacity,
            scale
        }
    };
};

export const animationOpacityMoveX = (startOpacity: number, startX: number | string, once?: boolean, rootMargin?: string) => {
    const ref = useRef<HTMLDivElement>(null);
    const inView = useInView(ref, buildArgs(once, rootMargin));

    const normalizedStartX = typeof startX === "string" ? parseFloat(startX) || 0 : startX;

    const opacity = useSpring(inView ? 1 : startOpacity, {stiffness: 100, damping: 20});
    const x = useSpring(inView ? 0 : normalizedStartX, {stiffness: 100, damping: 20});

    useEffect(() => {
        opacity.set(inView ? 1 : startOpacity);
        x.set(inView ? 0 : normalizedStartX);
    }, [inView, opacity, x, startOpacity, normalizedStartX]);
    return {
        ref,
        style: {
            opacity,
            x
        }
    };
};
import {useEffect, useRef} from "react";
import {css} from "@emotion/react";
import {useInView, useSpring} from "framer-motion";

export const pulseHeartbeatAnimation = (duration: string, iteration: string) => css`
    animation: heartbeat ${duration} ease-in-out ${iteration} both;

    @keyframes heartbeat {
        from {
            transform: scale(1);
            transform-origin: center center;
            animation-timing-function: ease-out;
        }
        10% {
            transform: scale(0.91);
            animation-timing-function: ease-in;
        }
        17% {
            transform: scale(0.98);
            animation-timing-function: ease-out;
        }
        33% {
            transform: scale(0.87);
            animation-timing-function: ease-in;
        }
        45% {
            transform: scale(1);
            animation-timing-function: ease-out;
        }
    }
`;

const buildArgs = (once?: boolean, rootMargin?: string) => {
    let args = {};
    if (once) {
        if (!!rootMargin) {
            args = {once: true, rootMargin: rootMargin};
        } else {
            args = {once: true};
        }
    }
    if (!!rootMargin && !once) {
        args = {rootMargin: rootMargin};
    }
    return args;
};

export const animationOpacityScale = (startOpacity: number, startScale: number, once?: boolean, rootMargin?: string) => {
    const ref = useRef<HTMLDivElement>(null);
    const inView = useInView(ref, buildArgs(once, rootMargin));

    const opacity = useSpring(inView ? 1 : startOpacity, {stiffness: 100, damping: 20});
    const scale = useSpring(inView ? 1 : startScale, {stiffness: 100, damping: 20});

    useEffect(() => {
        opacity.set(inView ? 1 : startOpacity);
        scale.set(inView ? 1 : startScale);
    }, [inView, opacity, scale, startOpacity, startScale]);

    return {
        ref,
        style: {
            opacity,
            scale
        }
    };
};

export const animationOpacityMoveX = (startOpacity: number, startX: number | string, once?: boolean, rootMargin?: string) => {
    const ref = useRef<HTMLDivElement>(null);
    const inView = useInView(ref, buildArgs(once, rootMargin));

    const normalizedStartX = typeof startX === "string" ? parseFloat(startX) || 0 : startX;

    const opacity = useSpring(inView ? 1 : startOpacity, {stiffness: 100, damping: 20});
    const x = useSpring(inView ? 0 : normalizedStartX, {stiffness: 100, damping: 20});

    useEffect(() => {
        opacity.set(inView ? 1 : startOpacity);
        x.set(inView ? 0 : normalizedStartX);
    }, [inView, opacity, x, startOpacity, normalizedStartX]);
    return {
        ref,
        style: {
            opacity,
            x
        }
    };
};
